(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "685bcfd7563f058c6c00d802";
              window.beaePageSetting.pageTitle = "whole sale"; 
              window.beaePageSetting.pageType = "page";

          let js_9HCL4RHN = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-rjdhky27section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rjdhky27',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rjdhky27');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rjdhky27: ', ex)
      };
    

      try {
        let argid = 'beae-oyx9me2fblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oyx9me2f',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oyx9me2f');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oyx9me2f: ', ex)
      };
    

      try {
        let argid = 'beae-md2f6av4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-md2f6av4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-md2f6av4');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-md2f6av4: ', ex)
      };
    

      try {
        let argid = 'beae-srcu5i8usection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-srcu5i8u',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-srcu5i8u');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-srcu5i8u: ', ex)
      };
    

      try {
        let argid = 'beae-173bqe2bblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-173bqe2b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-173bqe2b');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-173bqe2b: ', ex)
      };
    

      try {
        let argid = 'beae-173bqe2bblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-173bqe2b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-173bqe2b');
        args.el = args.els[1];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-173bqe2b: ', ex)
      };
    

      try {
        let argid = 'beae-173bqe2bblock-textloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-173bqe2b',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-173bqe2b');
        args.el = args.els[2];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-173bqe2b: ', ex)
      };
    

      try {
        let argid = 'beae-wdoxhdm7block-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-wdoxhdm7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-wdoxhdm7');
        args.el = args.els[0];
        ((m) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,p=m.el.querySelector("form");m.el.querySelector(".beae-btn-pr");const f=m.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=m.el.querySelector(".btn-lightbox-form > button");!h&&m.mode.value!=="builder"&&(m.el.querySelector(".beae-form-success-message").style="display: none"),h&&m.afterSubmitting=="redirect"&&m.redirect&&(m.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=m.redirect);const C=[];p&&p.addEventListener("submit",g=>{g.preventDefault();for(let _=0;_<f.length;_++)C.push({fieldKey:f[_].name,fieldType:f[_].type,fieldValue:f[_].value})}),b&&(b.onclick=()=>{const g=document.createElement("div");g.innerHTML=p.outerHTML||"",window.BeaePopupLibrary.createPopup(g,{layout:"center",layoutMobile:"bottom",width:"500px",id:m.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-wdoxhdm7: ', ex)
      };
    }; if (window.BEAEBASE) {js_9HCL4RHN()} else {window.BEAEPAGEJS.push(js_9HCL4RHN)} })(); 